/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TB License Platform API
 * Lean v1 controlled-pilot contract. One active Product Key allocates one
 * seat and may authorize at most one active Activation. Product Keys and
 * Activation Secrets are write-only delivery credentials and never appear in
 * admin read responses.
 *
 * OpenAPI spec version: 1.1.0
 */

export type APIActivitySettingsDebugOperationsItem = typeof APIActivitySettingsDebugOperationsItem[keyof typeof APIActivitySettingsDebugOperationsItem];


export const APIActivitySettingsDebugOperationsItem = {
  activate: 'activate',
  deactivate: 'deactivate',
  recovery_challenge: 'recovery_challenge',
  recover: 'recover',
  refresh: 'refresh',
  validate: 'validate',
  signing_keys: 'signing_keys',
  risk_signal: 'risk_signal',
  unknown: 'unknown',
} as const;
